/* Same pack-variant approach as the cleaning-cloth product: five colors and
   three pack sizes. Individual colors and SKU quantities are order properties. */
(()=>{
 function init(scope=document){
  for(const picker of scope.querySelectorAll('[data-ft-trivet-picker]')){
   const root=picker.closest('icp-product');if(!root?.ready||picker.ftReady)continue;
   picker.ftReady=true;
   const data=JSON.parse(picker.querySelector('[data-ft-trivet-config]').textContent);
   const configs=new Map(data.configs.map(c=>[c.key,c]));
   const configById=new Map(data.configs.map(c=>[c.id,c]));
   const variants=new Map(root.data.variants.map(v=>[v.id,v]));
   const state={count:3,colors:{1:[0],3:[0,0,0],5:[0,0,0,0,0]}};
   const deepLink=configById.get(Number(new URL(location.href).searchParams.get('variant')));
   if(deepLink){state.count=deepLink.count;state.colors[state.count]=deepLink.counts.flatMap((n,i)=>Array(n).fill(i));}
   const keyFor=colors=>colors.length+':'+colors[0];
   const configFor=colors=>configs.get(keyFor(colors));
   const set=(el,text)=>{if(el&&el.textContent!==text)el.textContent=text;};
   const selectedColor=picker.querySelector('[data-ft-selected-color]');
   function properties(config){
    const chosen=state.colors[state.count],counts=Array(5).fill(0);chosen.forEach(i=>counts[i]++);
    const props={'Bundle':config.label,'Included mats':String(state.count),'Color breakdown':counts.map((n,i)=>n?data.colors[i].name+' × '+n:'').filter(Boolean).join(', ')};
    chosen.forEach((i,n)=>props['Mat '+(n+1)+' color']=data.colors[i].name);
    props['_Component SKU breakdown']=counts.map((n,i)=>n?data.colors[i].sku+' × '+n:'').filter(Boolean).join('; ');
    root.form.querySelectorAll('[data-ft-property]').forEach(el=>el.remove());
    for(const [name,value]of Object.entries(props)){const input=document.createElement('input');input.type='hidden';input.name='properties['+name+']';input.value=value;input.dataset.ftProperty='';root.form.append(input);}
   }
   function sync(updateUrl=false,showImage=false){
    const config=configFor(state.colors[state.count]),variant=variants.get(config?.id);
    if(!variant){picker.querySelector('[data-ft-error]').textContent='This color combination is unavailable. Please choose another.';return;}
    picker.querySelector('[data-ft-error]').textContent='';
    for(const [index,value]of variant.options.entries()){
     const group=picker.querySelector('[data-icp-option="'+(index+1)+'"]');
     group.querySelectorAll('input').forEach(input=>input.checked=input.value===value);
    }
    root.sync(false);root.form.querySelector('[name="quantity"]').value='1';properties(config);
    for(const card of picker.querySelectorAll('[data-ft-bundle]')){
     const count=+card.dataset.ftBundle,selected=count===state.count,cardConfig=configFor(state.colors[count]),cardVariant=variants.get(cardConfig?.id);
     card.dataset.selected=String(selected);card.querySelector('[data-ft-bundle-radio]').checked=selected;
     card.querySelector('[data-ft-unit-pickers]').hidden=!selected;
     const base=variants.get(configs.get('1:0')?.id)?.price||0,saving=Math.max(0,base*count-(cardVariant?.price||0));
     set(card.querySelector('[data-ft-tier-price]'),root.money(cardVariant?.price||0));
     set(card.querySelector('[data-ft-tier-caption]'),count===1?'1 mat · Your everyday kitchen helper':count+' mats included · Save '+root.money(saving)+' vs buying separately');
     card.querySelectorAll('[data-ft-unit-color]').forEach(select=>{
      const i=+select.dataset.ftUnitColor,color=state.colors[count][i];select.value=String(color);
      const image=select.closest('.ft-unit').querySelector('img');if(image.src!==data.colors[color].image)image.src=data.colors[color].image;image.alt=data.colors[color].name+' mat';
     });
    }
    const first=state.colors[state.count][0];set(selectedColor,data.colors[first].name);
    picker.querySelectorAll('[data-ft-color]').forEach(button=>button.setAttribute('aria-pressed',String(+button.dataset.ftColor===first)));
    if(showImage){const native=variants.get(configFor([first]).id);if(native?.media)root.showMedia(native.media);}
    if(updateUrl){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}
    picker.dataset.ftVariant=String(variant.id);
   }
   picker.addEventListener('click',event=>{
    const color=event.target.closest('[data-ft-color]');
    if(color){const i=+color.dataset.ftColor;for(const count of [1,3,5])state.colors[count]=Array(count).fill(i);sync(true,true);return;}
    const card=event.target.closest('[data-ft-bundle]');
    if(card&&!event.target.closest('select')){state.count=+card.dataset.ftBundle;sync(true);}
   });
   picker.addEventListener('change',event=>{
    if(event.target.matches('[data-ft-unit-color]')){const card=event.target.closest('[data-ft-bundle]');state.colors[+card.dataset.ftBundle][+event.target.dataset.ftUnitColor]=+event.target.value;sync(true,+event.target.dataset.ftUnitColor===0);}
    else if(event.target.matches('[data-ft-bundle-radio]')){state.count=+event.target.value;sync(true);}
   });
   const upsell=root.querySelector('[data-ft-upsell]');
   if(upsell){const select=upsell.querySelector('select'),check=upsell.querySelector('[data-icx-attach]');select.addEventListener('change',()=>{check.dataset.icxAttachId=select.value;});}
   root.addEventListener('submit',()=>{sync(false);},true);
   root.querySelector('[data-icp-buy]')?.addEventListener('click',()=>sync(false),true);
   sync(false);picker.dispatchEvent(new CustomEvent('ft:ready'));
  }
 }
 const boot=()=>{let attempts=0;const retry=()=>{init();if(document.querySelector('[data-ft-trivet-picker]:not([data-ft-variant])')&&attempts++<80)setTimeout(retry,100);};customElements.whenDefined('icp-product').then(retry);};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
 document.addEventListener('shopify:section:load',boot);
})();
